import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Icon, IconButton, MuiThemeProvider, Tooltip, Typography} from '@material-ui/core';
import Toolbar from 'react-big-calendar/lib/Toolbar';
import {navigate} from 'react-big-calendar/lib/utils/constants';
import classNames from 'classnames';
import {FuseThemes, FuseAnimate} from '@fuse';
import moment from 'moment';
import {bindActionCreators} from "redux";
import ReduxCalender from "../../../../store/actionreducers/calender";
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import {constDataDialogs} from "../../../../constants";
import connect from "react-redux/es/connect/connect";


const viewNamesObj = {
    month: {
        title: '月',
        icon: 'view_module'
    },
    week: {
        title: '週',
        icon: 'view_week'
    },
    work_week: {
        title: '工作日',
        icon: 'view_array'
    },
    day: {
        title: '天',
        icon: 'view_day'
    },
    agenda: {
        title: '列表',
        icon: 'view_agenda'
    }
};

class CalendarHeader extends Toolbar {

    _getTitle({date, view, label}) {
        if (view === 'month') return moment(date).format('YYYY 年 MM 月');
        else if (view === 'week') return moment(date).startOf('week').format('MM 月 DD 日') + ' ~ ' + moment(date).endOf('week').format('MM 月 DD 日');
        else if (view === 'work_week') return moment(date).endOf('week').isoWeekday(1).format('MM 月 DD 日') + ' ~ ' + moment(date).endOf('week').isoWeekday(5).format('MM 月 DD 日');
        else if (view === 'day') return moment(date).format('YYYY 年 MM 月 DD 日');
        else if (view === 'agenda') return moment(date).startOf('month').format('YYYY/MM/DD') + ' ~ ' + moment(date).endOf('month').format('YYYY/MM/DD');
        else return label;
    }

    viewButtons() {
        let viewNames = this.props.views;
        const view = this.props.view;

        if (viewNames.length > 1) {
            return viewNames.map(name => (
                    <Tooltip title={viewNamesObj[name].title} key={name} disableFocusListener={true}>
                        <div>
                            <FuseAnimate animation="transition.expandIn" delay={500}>
                                <IconButton
                                    aria-label={name}
                                    onClick={() => this.props.onViewChange(name)}
                                    disabled={view === name}
                                >
                                    <Icon>{viewNamesObj[name].icon}</Icon>
                                </IconButton>
                            </FuseAnimate>
                        </div>
                    </Tooltip>
                )
            )
        }
    }

    async goToday({date, view, label}) {

    }


    async goPrev({date, view}) {

        const {getWorkEvents} = this.props;

        console.log('goPrev');

        if (view === 'month') {
            // TODO 取上個月的資料

            const lastMonth = moment(date).subtract(1, 'month');

            const startDate = lastMonth.startOf('month').toDate();
            const endDate = lastMonth.endOf('month').toDate();

            // const dateArray = dateUtil.getDailyDateArray({startDate, endDate});

            return await getWorkEvents({startDate, endDate});

        } else if (view === 'week') {
            // TODO 取上周的資料

            const lastWeek = moment(date).subtract(7, 'days');

            const startDate = lastWeek.startOf('week').toDate();
            const endDate = lastWeek.endOf('week').toDate();

            // const dateArray = dateUtil.getDailyDateArray({startDate, endDate});

            return await getWorkEvents({startDate, endDate});

        } else if (view === 'work_week') {

            // TODO 取上周的資料

            const lastWeek = moment(date).subtract(7, 'days');

            const startDate = lastWeek.startOf('week').isoWeekday(1).toDate();
            const endDate = lastWeek.endOf('week').isoWeekday(5).toDate();

            // const dateArray = dateUtil.getDailyDateArray({startDate, endDate});

            return await getWorkEvents({startDate, endDate});

        } else if (view === 'day') {

            const lastDay = moment(date).subtract(1, 'days');

            // TODO 取昨天的資料
            return await getWorkEvents({startDate: lastDay, endDate: lastDay});


        } else return '';
    }


    async goNext({date, view, label}) {

    }

    render() {
        const {classes, label, date, view} = this.props;

        return (
            <MuiThemeProvider theme={FuseThemes['mainThemeDark']}>

                <div className={classNames(classes.root, moment(date).format('MMM'))}>

                    <div className="flex flex-1 flex-col p-12 justify-between z-10">

                        <div className="flex flex-col items-center justify-between sm:flex-row">
                            <div className="flex items-center my-16 sm:mb-0">
                                <FuseAnimate animation="transition.expandIn" delay={300}>
                                    <Icon className="text-32 mx-12">today</Icon>
                                </FuseAnimate>
                                <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                    <Typography variant="title">醫師排班</Typography>
                                </FuseAnimate>
                            </div>
                            <div className="flex items-center">
                                <Tooltip title="Today" disableFocusListener={true}>
                                    <FuseAnimate animation="transition.expandIn" delay={500}>
                                        <IconButton aria-label="today"
                                                    onClick={this.navigate.bind(null, navigate.TODAY)}>
                                            <Icon>today</Icon>
                                        </IconButton>
                                    </FuseAnimate>
                                </Tooltip>
                                {this.viewButtons()}
                            </div>
                        </div>

                        <FuseAnimate delay={500}>
                            <div className="flex items-center justify-center">
                                <Tooltip title="向前" disableFocusListener={true}>
                                    <IconButton aria-label="Previous"
                                                onClick={this.navigate.bind(null, navigate.PREVIOUS)}>
                                        <Icon>chevron_left</Icon>
                                    </IconButton>
                                </Tooltip>
                                <Typography variant="title">{this._getTitle({date, view, label})}</Typography>
                                <Tooltip title="向後" disableFocusListener={true}>
                                    <IconButton aria-label="Next" onClick={this.navigate.bind(null, navigate.NEXT)}>
                                        <Icon>chevron_right</Icon>
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </FuseAnimate>
                    </div>
                </div>
            </MuiThemeProvider>
        )
    };
}

const styles = theme => ({
    root: {
        height: 200,
        minHeight: 200,
        display: 'flex',
        backgroundImage: 'url("../../assets/images/backgrounds/header-bg.png")',
        backgroundColor: '#FAFAFA',
        color: '#FFFFFF',
        backgroundSize: 'cover',
        backgroundPosition: '0 50%',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        '&:before': {
            content: "''",
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 1,
            background: 'rgba(0, 0, 0, 0.45)'
        },
        '&.Jan': {
            backgroundImage: "url('/assets/images/backgrounds/winter.jpg')",
            backgroundPosition: '0 85%'
        },
        '&.Feb': {
            backgroundImage: "url('/assets/images/backgrounds/winter.jpg')",
            backgroundPosition: '0 85%'
        },
        '&.Mar': {
            backgroundImage: "url('/assets/images/backgrounds/spring.jpg')",
            backgroundPosition: '0 40%'
        },
        '&.Apr': {
            backgroundImage: "url('/assets/images/backgrounds/spring.jpg')",
            backgroundPosition: '0 40%'
        },
        '&.May': {
            backgroundImage: "url('/assets/images/backgrounds/spring.jpg')",
            backgroundPosition: '0 40%'
        },
        '&.Jun': {
            backgroundImage: "url('/assets/images/backgrounds/summer.jpg')",
            backgroundPosition: '0 80%'
        },
        '&.Jul': {
            backgroundImage: "url('/assets/images/backgrounds/summer.jpg')",
            backgroundPosition: '0 80%'
        },
        '&.Aug': {
            backgroundImage: "url('/assets/images/backgrounds/summer.jpg')",
            backgroundPosition: '0 80%'
        },
        '&.Sep': {
            backgroundImage: "url('/assets/images/backgrounds/autumn.jpg')",
            backgroundPosition: '0 40%'
        },
        '&.Oct': {
            backgroundImage: "url('/assets/images/backgrounds/autumn.jpg')",
            backgroundPosition: '0 40%'
        },
        '&.Nov': {
            backgroundImage: "url('/assets/images/backgrounds/autumn.jpg')",
            backgroundPosition: '0 40%'
        },
        '&.Dec': {
            backgroundImage: "url('/assets/images/backgrounds/winter.jpg')",
            backgroundPosition: '0 85%'
        }
    }
});


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getWorkEvents: ReduxCalender.ActionCreator.getWorkEvents,
        closeDataDialog: ReduxGlobal.ActionCreator.closeDataDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
    }, dispatch);
}

function mapStateToProps({global: {dataDialog, dataDialogs}}) {

    return {
        vipDialog: dataDialogs[constDataDialogs.name.vipDialog],
        dataDialog,
    }
}


export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(CalendarHeader));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/calendar/CalendarHeader.js